// Product pricing helpers — mirror of server/utils/pricing.js so the storefront
// display and cart totals match what the server (authoritative) actually charges.
//
// A product may carry a `comparePrice` ("İndirimli Fiyat"). When it is a valid
// discount (0 < comparePrice < price) it is the amount the customer pays and `price`
// is shown struck-through. Otherwise the normal `price` applies (unchanged behavior).

interface Priced {
  price?: number;
  comparePrice?: number;
}

/** The effective unit price the customer is charged. */
export const getEffectivePrice = (product?: Priced | null): number => {
  if (!product) return 0;
  const price = Number(product.price) || 0;
  const compare = Number(product.comparePrice) || 0;
  return compare > 0 && compare < price ? compare : price;
};

/** Whether the product is currently discounted. */
export const isDiscounted = (product?: Priced | null): boolean => {
  if (!product) return false;
  const price = Number(product.price) || 0;
  const compare = Number(product.comparePrice) || 0;
  return compare > 0 && compare < price;
};

/** Discount percentage (rounded) for display, e.g. 50 for "-%50". 0 when not discounted. */
export const discountPercent = (product?: Priced | null): number => {
  if (!isDiscounted(product)) return 0;
  const price = Number(product!.price) || 0;
  const compare = Number(product!.comparePrice) || 0;
  return Math.round(((price - compare) / price) * 100);
};
